<template>
  <NodeViewWrapper
    class="image-resizer"
    :class="{
      'ProseMirror-selectednode': selected && editor.isEditable,
      inline: options.inline,
      outLine: selected
    }"
    :style="{ border: '3px solid rgba(255, 255, 255, 0)', margin: '8px 0' }"
  >
    <toolls ref="tools" @getWidth="getWidth"></toolls>
    <div v-if="selected" class="topLeftS dragS" @mousedown="mouseDown"></div>
    <div v-if="selected" class="topRightS dragS" @mousedown="mouseDown"></div>
    <div
      v-if="selected"
      class="bottomLeftS dragS"
      @mousedown="mouseDown"
      @mouseup="mouseUp"
      @mouseout="mouseUp"
    ></div>
    <div v-if="selected" class="bottomRightS dragS" @mousedown="mouseDown"></div>
    <el-popover
      trigger="hover"
      placement="top"
      width="200"
      popper-class="topHead"
      :value="selectedS"
    >
      <div class="topHead-content">
        <span
          class="text"
          @click="setWidth(0)"
          :class="{ selectedStyle: '100%' === defaultWidth }"
          >{{ fontData[0] }}</span
        >
        <span class="line"></span>
        <span
          class="text"
          @click="setWidth(1)"
          :class="{ selectedStyle: '250px' === defaultWidth }"
          >{{ fontData[1] }}</span
        >
        <span class="line"></span>
        <span
          class="text"
          @click="setWidth(2)"
          :class="{ selectedStyle: '400px' === defaultWidth }"
          >{{ fontData[2] }}</span
        >
      </div>
      <img
        ref="imgRef"
        slot="reference"
        :src="attrs.src"
        :alt="attrs.alt"
        :title="attrs.title"
        :style="{
          width: firstLoading && attrs.width ? attrs.width : defaultWidth,
          height: defaultHeight
        }"
      />
    </el-popover>
  </NodeViewWrapper>
</template>

<script>
// filepath: d:\snowfee\classnovo\backmanage\src\common\imgae\ImageWithTool.vue
import { NodeViewWrapper } from '@tiptap/vue-2'
import toolls from './tools'

export default {
  name: 'ImageWithTool',
  components: {
    NodeViewWrapper,
    toolls
  },
  props: {
    editor: { type: Object, required: true },
    node: { type: Object, required: true },
    extension: { type: Object, required: true }
    // 如果还有其他 props，请在这里列出
  },
  provide() {
    return {
      tiptapProps: this.$props
    }
  },
  data() {
    return {
      vw: 0,
      vh: 0,
      imgScale: 1,
      selectedS: false,
      fontData: ['Original', '250px', '400px'],
      defaultSize: 'Original',
      imgWidth: '',
      imgHeight: '',
      imgWidth_: '',
      imgHeight_: '',
      moveWidth: 0,
      moveHeight: 0,
      canMove: false,
      firstLoading: true
    }
  },
  computed: {
    attrs() {
      return this.node.attrs
    },
    options() {
      return this.extension.options
    },
    // 重命名计算属性，避免与 prop 冲突
    // selected() {
    //   return this.editor.isActive && this.editor.isActive('image');
    // },
    defaultHeight() {
      if (this.imgHeight) {
        return this.imgHeight + 'px'
      } else {
        return '100%'
      }
    },
    defaultWidth() {
      if (this.imgWidth) {
        return this.imgWidth + 'px'
      } else {
        return '100%'
      }
    }
  },
  created() {
    this.vw = 200 + 'px'
    this.vh = 200 + 'px'
  },
  mounted() {
    setTimeout(() => {
      this.selectedS = true
      if (this.$refs.imgRef) {
        this.imgScale = this.$refs.imgRef.offsetHeight / this.$refs.imgRef.offsetWidth
      }
    }, 1000)
  },
  methods: {
    getWidth(data) {
      console.log(242424)
      console.log(data.node.attrs)
      if (data.node.attrs.width === 'auto' || data.node.attrs.width === '100%') {
      } else {
        this.imgWidth = Number(data.node.attrs.width.replace('px', ''))
      }
    },
    clickOut() {
      this.selectedS = false
    },
    setWidth(index) {
      this.firstLoading = false
      this.selectedS = false
      if (index === 0) {
        this.imgWidth = ''
        this.imgHeight = ''
      } else if (index === 1) {
        this.imgWidth = 250
        this.imgHeight = ''
      } else if (index === 2) {
        this.imgWidth = 400
        this.imgHeight = ''
      }
      setTimeout(() => {
        this.selectedS = true
      }, 100)
      this.$refs.tools.onMouseMove(this.defaultWidth, this.defaultHeight)
    },
    mouseDown(e) {
      this.canMove = true
      this.imgWidth_ = this.$refs.imgRef.offsetWidth
      this.imgHeight_ = this.$refs.imgRef.offsetHeight
      this.imgWidth = this.$refs.imgRef.offsetWidth
      this.imgHeight = this.$refs.imgRef.offsetHeight
      this.moveWidth = e.x
      this.moveHeight = e.x * this.imgScale
      document.body.addEventListener('mousemove', this.mouseMove)
      document.body.addEventListener('mouseup', this.removeEventListener, { once: true })
      document.body.addEventListener('mouseleave', this.removeEventListener, { once: true })
    },
    removeEventListener() {
      this.canMove = false
      document.body.removeEventListener('mousemove', this.mouseMove)
      document.body.removeEventListener('mouseup', this.removeEventListener)
      document.body.removeEventListener('mouseleave', this.removeEventListener)
      this.$refs.tools.onMouseMove(this.defaultWidth, this.defaultHeight)
      setTimeout(() => {
        this.selectedS = true
      }, 100)
    },
    mouseUp(e) {
      // this.canMove = false;
    },
    mouseMove(e) {
      if (this.canMove === true) {
        this.firstLoading = false
        this.selectedS = false
        this.defaultSize = ''
        this.imgWidth = e.x - this.moveWidth + this.imgWidth_
        this.imgHeight = e.x * this.imgScale - this.moveHeight + this.imgHeight_
      }
    },
    toSelect() {
      this.selectedS = true
    },
    resize(newRect) {
      this.vw = newRect.width
      this.vh = newRect.height
      this.top = newRect.top
      this.left = newRect.left
    }
  }
}
</script>

<style lang="less">
.image-resizer {
  border: 3px solid rgba(255, 255, 255, 0);
  max-width: 100%;
  position: relative;
  width: fit-content;
  .el-popover__reference {
    padding: 0 !important;
  }

  &.inline {
    display: inline-block;
  }
  .el-popover__reference-wrapper {
    display: block;
    // padding: 4px;
    img {
      transform-origin: left top;
      user-select: none; /* 这会阻止用户选择图片上的文本 */
      -webkit-user-drag: none; /* Chrome/Safari/Opera */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE/Edge */
    }
  }

  .maxw100 {
    width: 100%;
  }
}
.outLine {
  border: 3px solid rgb(0, 208, 228) !important;
  cursor: pointer;
}
.dragS {
  background-color: rgb(0, 208, 228);
  height: 8px;
  width: 8px;
  opacity: 1;
  position: absolute;
  border: 1px solid white;
  cursor: nwse-resize;
}
.topLeftS {
  top: -5px;
  left: -5px;
}
.topRightS {
  top: -5px;
  cursor: nesw-resize;
  right: -5px;
}
.bottomRightS {
  bottom: -5px;
  right: -5px;
}
.bottomLeftS {
  bottom: -5px;
  left: -5px;
  cursor: nesw-resize;
}
.topHead {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid #cbd6e2;
  padding: 0;
  &-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
  }
  .text {
    padding: 0 8px;
    color: #0091ae;
    font-size: 14px;
    font-family: OpenSans-Bold;
    display: inline-block;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .selectedStyle {
    color: #b0c1d4;
    &:hover {
      text-decoration: none;
    }
  }
  .line {
    height: 20px;
    display: inline-block;
    width: 1px;
    background-color: #cbd6e2;
  }
}
</style>
